import React, { forwardRef, type ComponentProps } from 'react';
import { genesisStyled } from './genesisStyled';
import css from './css';
import { Box } from '../Box';

// For reference: https://a11yproject.com/posts/how-to-hide-content/
// And: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
export const visuallyHidden = Object.freeze({
  ':not(:focus):not(:active)': {
    position: 'absolute',
    height: 1,
    width: 1,
    overflow: 'hidden',
    clip: 'rect(1px, 1px, 1px, 1px)',
    whiteSpace: 'nowrap',
  },
});

const VisuallyHiddenBase = genesisStyled(Box)(css(visuallyHidden));

export const VisuallyHidden = forwardRef<
  HTMLElement,
  ComponentProps<typeof VisuallyHiddenBase>
>(({ as = 'span', ...props }, ref) => (
  <VisuallyHiddenBase as={as} ref={ref} {...props} />
));

VisuallyHidden.displayName = 'VisuallyHidden';
